import React from "react";
import "@fontsource/shippori-mincho/400.css";
import "@fontsource/shippori-mincho/500.css";
import "@fontsource/shippori-mincho/700.css";
import "@fontsource/zen-kaku-gothic-new/300.css";
import "@fontsource/zen-kaku-gothic-new/400.css";
import "@fontsource/zen-kaku-gothic-new/500.css";
import "./src/styles/global.css";
import Layout from "./src/components/Layout";

export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;
export const shouldUpdateScroll = () => false;
